import React, { useMemo } from 'react';
import { Alert, Input, Spin } from "antd";
import { useForm, FormProvider } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import * as actionCreators from "../../store/actions/index";
import FormItem from '../FormItem/FormItem';
import Form from '../Form/Form';
import FormButtons from '../FormButtons/FormButtons';
import { isObjectNotEmpty } from '../../shared/objectUtils';

const EditConfiguration = ({ cancel, configuration }) => {
    const methods = useForm({ mode: 'all', reValidateMode: 'onChange', criteriaMode: 'all', shouldFocusError: true, shouldUnregister: true });

    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.configurations.isRecordUpdateLoading);
    const error = useSelector(state => state.configurations.updateRecordError);

    const onSubmit = (data) => {
        let payload = {};
        let objectToUpdate = { ...configuration };
        for (let [key, value] of Object.entries(data)) {
            let oldValue = objectToUpdate[key] !== undefined && objectToUpdate[key] !== null ? objectToUpdate[key] : '';
            if (value !== oldValue) {
                //console.log(`${key}: new value - ${value}, old value - ${oldValue}`);
                payload[key] = value;
            }
        }

        if (isObjectNotEmpty(payload)) {
            dispatch(actionCreators.updateConfiguration(configuration.id, payload));
        } else {
            onCancel();
        }
    };

    const onCancel = () => {
        dispatch(actionCreators.updateConfigurationCancel());
        cancel();
    };

    useMemo(() => {
        // clear any previous errors if this is a new form
        dispatch(actionCreators.updateConfigurationErrorClear());
    }, []);

    useMemo(() => {
        if (isLoading !== null && isLoading === false && error === null) {
            onCancel();
        }
    }, [isLoading, error]);

    const formItemLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    return (
        <FormProvider {...methods}>
            <Form onSubmit={methods.handleSubmit(onSubmit)}>
                <Spin style={{ height: '100%', width: '100%' }} size="large" spinning={isLoading === true && error === null}>
                    <FormItem {...formItemLayout} label="Name" required
                        render={({ onChange, onBlur, value, name, ref }) => <Input onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} placeholder="Name" ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="name"
                        defaultValue={configuration.name}
                        disabled={true}
                    />
                    <FormItem {...formItemLayout} label="Customer Support Phone #" required
                        render={({ onChange, onBlur, value, name, ref }) => <Input onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} placeholder="Customer Support Phone #" ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="companyPhoneNumber"
                        defaultValue={configuration.companyPhoneNumber}
                    />
                    <FormItem {...formItemLayout} label="Geo Fence Radius (in miles)" required
                        render={({ onChange, onBlur, value, name, ref }) => <Input onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} placeholder="Geo Fence Radius" ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="geoFenceRadius"
                        defaultValue={configuration.geoFenceRadius}
                    />
                    <FormItem {...formItemLayout} label="Location Distance Interval (in miles)" required
                        render={({ onChange, onBlur, value, name, ref }) => <Input onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} placeholder="Location Distance Interval" ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="locationDistanceInterval"
                        defaultValue={configuration.locationDistanceInterval}
                    />
                    <FormItem {...formItemLayout} label="Location Time Interval (in seconds)" required
                        render={({ onChange, onBlur, value, name, ref }) => <Input onBlur={onBlur} onChange={e => { onChange(e.target.value); }} value={value} name={name} placeholder="Location Time Interval" ref={ref} />}
                        rules={{ required: 'Required Field' }}
                        name="locationTimeInterval"
                        defaultValue={configuration.locationTimeInterval}
                    />
                    {error && <Alert message={`${error}`} type="error" />}
                </Spin>
                <FormButtons cancel={onCancel} disabled={isLoading === true && error === null} submitText="Update Configuration" />
            </Form>
        </FormProvider>
    );
};

export default EditConfiguration;